import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import {useEffect, useState} from "react";
import DiscountCard, {ActiveDiscountCard} from "./DiscountCard";
import Api from "../../tools/service";
import RequestUrl from "../../tools/defaults/requestUrl";
import LoadingScreen from "../LoadingScreen";

const Discount = ({processInfo,pid,prices, getProcess, token, onClick}) => {

    const [discountPercent, setDiscountPercent] = useState(0);
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    const [discountLoading, setDiscountLoading] = useState(false);
    const [discountError, setDiscountError] = useState('');
    const [deleteDiscountLoading, setDeleteDiscountLoading] = useState(false)
    const [deleteDiscountError, setDeleteDiscountError] = useState('')
    const [price, setPrice] = useState(null);
    const [discountPreLoading, setDiscountPreLoading] = useState(true);

    useEffect(() => {
        if(processInfo){
            setPrice(prices[0].price);
        }
        if (processInfo?.discount) {
            setDiscountPercent(processInfo.discount.props['CService'].post_add_on);
            setPrice(prices[0].price);
            setDiscountPreLoading(false)
        } else {
            if (localStorage.getItem('discount_code')&&processInfo.payment.payment_required) {
                setDiscountPreLoading(true)
                const params = {
                    pid: pid,
                    code: localStorage.getItem('discount_code')
                }
                Api.post(RequestUrl.CAR_SERVICES.DISCOUNT, params, {

                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }).then(response => {
                    localStorage.removeItem('discount_code');
                    setDiscountPreLoading(false)
                    if (response.hasError) {

                    } else {
                        getProcess(pid)
                    }
                }).finally(() => {

                })
            } else {
                setDiscountPercent(0)
                setDiscountPreLoading(false)
            }

        }

    }, [processInfo]);
    const handleDiscount = (discount_code) => {
        setDiscountLoading(true);
        const data = {
            pid: pid,
            code: discount_code,
        }
        Api.post(RequestUrl.CAR_SERVICES.DISCOUNT, data, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.hasError) {
                setDiscountError(response.message);
            } else {
                getProcess(pid)
            }
        }).finally(() => {
            setDiscountLoading(false);
        })

    }
    const handleDeleteDiscount = () => {
        setDeleteDiscountLoading(true);
        const params = {
            pid: pid,
        }
        Api.delete(RequestUrl.CAR_SERVICES.DISCOUNT, {
            params,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.hasError) {
                setDeleteDiscountError(response.message);
            } else {
                getProcess(pid)
            }
        }).finally(() => {
            setDeleteDiscountLoading(false);
        })
    }
    const DiscountBadge = () => {
        if (discountPercent === 0) {
            return null
        }
        if (discountPercent === 100) {
            return <div
                className="text-sm rounded-full bg-green-500 text-white px-3 py-1 absolute -top-3 right-2">{`رایگان`}</div>
        }
        return <div
            className="text-sm rounded-full bg-green-500 text-white px-3 py-1 absolute -top-3 right-2">{`${discountPercent}% تخفیف`}</div>
    }
    const Price = () => {
        if(processInfo?.payment?.payment_required===false) {
            return <div className="flex justify-end items-center">
                     <span className="font-semibold text-green-500">
                        رایگان
                     </span>
            </div>
        } else if (discountPercent === 100) {
            return <div className="flex justify-between items-center">
                <span className="line-through text-red-500">{formattedPrice.format(prices[0].price / 10)}
                    <span className="mr-1">تومان</span></span>
                <span className="font-semibold text-green-500">رایگان</span>
            </div>
        } else if (discountPercent === 0) {
            return <div className="flex justify-end items-center">
                <span className="font-semibold text-green-500">{formattedPrice.format(prices[0].price / 10)}
                    <span className="mr-1">تومان</span></span>

            </div>
        } else return <div className="flex justify-between items-center">
            <span className="line-through text-sm text-red-500">{formattedPrice.format(prices[0].price / 10)}
                <span className="mr-1">تومان</span></span>
            <span
                className=" font-semibold text-green-500">{formattedPrice.format((price - (price * discountPercent / 100)) / 10)}
                <span className="mr-1">تومان</span></span>
        </div>
    }
    if(discountPreLoading){
        return  <LoadingScreen/>
    }
    return <div className="h-full mx-auto  ">
        <h1 className="font-bold text-xl  mt-3 text-center mb-3 ">ونش</h1>
        <div className="bg-white p-5 relative mb-1 rounded-lg shadow-sm  ">
            <DiscountBadge/>
            <h1 className="font-semibold">گواهی اصالت خودرو</h1>
            <p className="text-sm">این تاییدیه باعث افزایش بازدید آگهی شما شده و فروش  را برایتان آسان‌تر
                می‌سازد.</p>
            {price !== null && <Price/>}
        </div>
        {processInfo?.payment?.payment_required===true  && <>
            {!processInfo?.discount &&
                <DiscountCard errorMessage={discountError} loading={discountLoading} onConfirm={handleDiscount}/>}
            {processInfo?.discount && <ActiveDiscountCard
                canDelete={true}
                loading={deleteDiscountLoading}
                error={deleteDiscountError}
                code={processInfo?.discount?.code}
                onDelete={handleDeleteDiscount}/>}
        </>}

        <BottomButtonWrapper><Button onClick={onClick} rounded="rounded-lg" className="text-sm" theme="blue">مرحله
            بعد</Button></BottomButtonWrapper>
    </div>
}
export default Discount;